/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderSubtotalsRoutingModule
 * Purpose		: Routing module for OrderSubtotals.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OrderSubtotalsListComponent } from './OrderSubtotalsList.component';
import { OrderSubtotalsDetailsComponent } from './OrderSubtotalsDetails.component';

const OrderSubtotalsRoutes: Routes = [
	{ path: 'OrderSubtotals',  component: OrderSubtotalsListComponent },
	{ path: 'OrderSubtotals/Details/:id', component: OrderSubtotalsDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(OrderSubtotalsRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class OrderSubtotalsRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderSubtotals/OrderSubtotals-routing.module.ts